import { createCrudStore } from "@/store/crudStore";
import { apiService } from "@/services/api";

const gastosTercerizadosStore = createCrudStore("gastos-tercerizados");

export default {
  ...gastosTercerizadosStore,

  state: {
    ...gastosTercerizadosStore.state,
    filtros: {
      desde: null,
      hasta: null,
      categoria: null,
    },
  },

  getters: {
    ...gastosTercerizadosStore.getters,
    gastos(state) {
      return Array.isArray(state["gastos-tercerizados"])
        ? state["gastos-tercerizados"]
        : [];
    },
    filtros(state) {
      return state.filtros;
    },
  },

  mutations: {
    ...gastosTercerizadosStore.mutations,
    setFiltros(state, filtros) {
      state.filtros = { ...state.filtros, ...filtros };
    },
    clearFiltros(state) {
      state.filtros = { desde: null, hasta: null, categoria: null };
    },
  },

  actions: {
    ...gastosTercerizadosStore.actions,

    async getGastos({ commit, state }) {
      commit("setLoading", true);
      try {
        const params = new URLSearchParams();
        if (state.filtros.desde) params.append("desde", state.filtros.desde);
        if (state.filtros.hasta) params.append("hasta", state.filtros.hasta);
        if (state.filtros.categoria)
          params.append("categoria", state.filtros.categoria);

        const url = params.toString()
          ? `gastos-tercerizados?${params.toString()}`
          : "gastos-tercerizados";

        const response = await apiService.getCustom(url);
        commit("setState", response.data);
        return response;
      } catch (error) {
        commit("setError", "Error al obtener gastos tercerizados");
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },

    async postGasto({ dispatch }, payload) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.postCustom("gastos-tercerizados", payload),
        onSuccessCallback: async () => {
          await dispatch("getGastos");
        },
        errorMessage: "Error al registrar gasto tercerizado",
      });
    },

    async patchGasto({ dispatch }, { id, payload }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.patchCustom(`gastos-tercerizados/${id}`, payload),
        onSuccessCallback: async () => {
          await dispatch("getGastos");
        },
        errorMessage: "Error al actualizar gasto tercerizado",
      });
    },

    async deleteGasto({ dispatch }, id) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.deleteCustom(`gastos-tercerizados/${id}`),
        onSuccessCallback: async () => {
          await dispatch("getGastos");
        },
        errorMessage: "Error al eliminar gasto tercerizado",
      });
    },

    setFiltros({ commit, dispatch }, filtros) {
      commit("setFiltros", filtros);
      return dispatch("getGastos");
    },

    clearFiltros({ commit, dispatch }) {
      commit("clearFiltros");
      return dispatch("getGastos");
    },
  },
};
